<template>
  <div>
    <masterList
      :tableColumns="tableColumns"
      :module="'assets'"
      :addNew="addNew"
    ></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  computed:{
    ...mapState({
         language_terms: state => state.languages.language_terms,
    })

  },
  components: {
    masterList,
  },

  data() {
    return {
      addNew: "/assets-management/asset/_new",
       tableColumns: [
              {
                prop: 'code',
                label: 'CODE',
                minWidth: 100,
                sortable: true,
                key:'CODE'
              },
              {
                prop: 'name',
                label: 'NAME',
                minWidth: 180,
                sortable: true,
                key:'NAME'
              },

              {
                prop: 'rfid_code',
                label: 'RFID',
                minWidth: 100,
                sortable: true,
                key:'RFID'
              },
              {
                prop: 'assetclassification_name',
                label: ' ASSET_CLASSIFICATION',
                minWidth: 120,
                sortable: true,
                key:'ASSET_CLASSIFICATION'
              },
              {
                prop: 'reference',
                label: 'REFERENCE',
                minWidth: 140,
                sortable: true,
                key:'REFERENCE'
              },
        ],

    };
  },
  watch:{
          language_terms: {
            handler(val){
                this.updateTableLang()
            }
        }
  },
  mounted(){
     this.updateTableLang()
  },
  methods:{
    updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    }

  }
};
</script>

<style>
</style>